<template>
  <div class="chat d-flex">
    <userList/>
    <chatDetail/>
    <orderDetail/>
  </div>
</template>

<script>
import userList from './components/userList.vue'
import chatDetail from './components/chatDetail.vue'
import orderDetail from './components/orderDetail.vue'

export default {
  components: {
    userList,
    chatDetail,
    orderDetail
  },
  name:'index',
  data() {
    return {
      
    }
  }
}
</script>

<style lang="scss" scoped>
.chat {
  width:100vw;
  height: 100%;
}
</style>